import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

console.log('Starting application...');

try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found! Check your index.html file.');
  }

  console.log('Creating React root...');
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('Application rendered successfully');
} catch (error) {
  console.error('Fatal error starting application:', error);
  document.body.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #1a1b1e;
      color: white;
      font-family: system-ui, -apple-system, sans-serif;
    ">
      <div style="
        text-align: center;
        padding: 2rem;
        background-color: #2c2d31;
        border-radius: 0.5rem;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      ">
        <h1 style="margin-bottom: 1rem; font-size: 1.5rem; font-weight: bold;">Application Error</h1>
        <p style="color: #a1a1aa;">${error.message}</p>
      </div>
    </div>
  `;
} 